import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { TaskSlice, createTaskSlice } from './slices/taskSlice';
import { MessageSlice, createMessageSlice } from './slices/messageSlice';
import { AuthSlice, createAuthSlice } from './slices/authSlice';
import { SettingsSlice, createSettingsSlice } from './slices/settingsSlice';
import { NotificationSlice, createNotificationSlice } from './slices/notificationSlice';
import { SystemSettingsSlice, createSystemSettingsSlice } from './slices/systemSettingsSlice';
import { EmployeeSlice, createEmployeeSlice } from './slices/employeeSlice';

type StoreState = TaskSlice & 
  MessageSlice & 
  AuthSlice & 
  SettingsSlice & 
  NotificationSlice &
  SystemSettingsSlice &
  EmployeeSlice;

export const useStore = create<StoreState>()(
  persist(
    (set) => ({
      ...createTaskSlice(set),
      ...createMessageSlice(set),
      ...createAuthSlice(set),
      ...createSettingsSlice(set),
      ...createNotificationSlice(set),
      ...createSystemSettingsSlice(set),
      ...createEmployeeSlice(set),
      tasks: [], 
      messages: [],
      currentUser: null,
      setUser: (user) => set({ currentUser: user }),
    }),
    {
      name: 'sf-naturals-storage',
      version: 2,
      partialize: (state) => ({
        userSettings: state.userSettings,
        systemSettings: state.systemSettings
      })
    }
  )
);